import { useState } from 'react';
import { collegeApi } from './shared';

export const CollegeGate = ({ onUnlock }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim() || busy) return;
    setBusy(true);
    setError('');
    try {
      const r = await collegeApi.post('/college/access', { code: code.trim() });
      sessionStorage.setItem('upa_college_token', r.data.token);
      onUnlock(r.data.label);
    } catch (err) {
      setError(err.response?.data?.detail || 'Access failed — please try again');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative overflow-hidden" style={{ background: '#050505' }} data-testid="college-gate">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true" style={{
        background: 'radial-gradient(ellipse 70% 50% at 70% 20%, rgba(112,0,255,0.22), transparent 60%), radial-gradient(ellipse 50% 40% at 15% 85%, rgba(255,0,127,0.14), transparent 60%)',
      }} />
      <div className="relative w-full max-w-md text-center">
        <img src="/upa-splash-logo.jpg" alt="Universal Performing Arts" className="w-28 h-auto object-contain mx-auto mb-8" style={{ mixBlendMode: 'screen' }} />
        <p className="text-[#FFD700] text-xs uppercase tracking-[0.35em] mb-3 font-semibold">UPA College</p>
        <h1 className="font-heading text-3xl sm:text-4xl text-white mb-2">Private Investment &amp; Partnership Presentation</h1>
        <p className="text-white/50 text-sm mb-10">Enter your access code to view the presentation.</p>
        <form onSubmit={submit} className="rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-xl p-6">
          <label htmlFor="college-code" className="sr-only">Access code</label>
          <input
            id="college-code"
            data-testid="college-access-input"
            type="password"
            autoComplete="off"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter Access Code"
            className="w-full text-center tracking-widest text-lg px-4 py-4 rounded-xl bg-black/50 border border-white/15 text-white placeholder-white/30 focus:outline-none focus:border-[#FF007F] transition-colors"
          />
          {error && <p className="text-[#FF007F] text-sm mt-3" role="alert" data-testid="college-access-error">{error}</p>}
          <button
            type="submit"
            disabled={busy}
            data-testid="college-access-submit"
            className="w-full mt-4 py-4 rounded-xl font-bold text-white text-base transition-transform hover:scale-[1.02] disabled:opacity-60"
            style={{ background: 'linear-gradient(90deg, #FF007F, #7000FF)' }}
          >
            {busy ? 'Checking…' : 'Enter Presentation'}
          </button>
        </form>
        <p className="text-white/35 text-xs mt-8 leading-relaxed">
          This presentation contains a proposed development concept shared for exploratory partnership discussions.
        </p>
      </div>
    </div>
  );
};
